import { useState, useEffect } from 'react';
import axios from 'axios';
import getAppAPIBase from 'utils/getAppAPIBase';

/**
 * Fetch external auth flags (SSO + social) for the login page.
 * Backend GET .../auth/config returns sso_enabled and social_login_enabled — used for
 * WorkOS (Google + SSO) and the Microsoft Entra button (same social_login_enabled gate).
 *
 * @param {string} clientId - Client route/slug from URL
 * @returns {{ config: { sso_enabled, google_login_enabled, microsoft_login_enabled, password_login_enabled }|null, loading: boolean }}
 */
export default function useExternalAuthConfig(clientId) {
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!clientId) {
            setLoading(false);
            return;
        }
        const base = getAppAPIBase(clientId);
        axios
            .get(`${base}/auth/config`)
            .then(res => {
                const data = res.data?.data ??
                    res.data ?? {
                        sso_enabled: false,
                        google_login_enabled: false,
                        social_login_enabled: false,
                        microsoft_login_enabled: false,
                        password_login_enabled: true,
                    };
                setConfig({
                    sso_enabled: !!data.sso_enabled,
                    google_login_enabled: !!data.google_login_enabled,
                    microsoft_login_enabled: !!data.microsoft_login_enabled,
                    password_login_enabled: data.password_login_enabled !== false,
                });
            })
            .catch(() => {
                setConfig({
                    sso_enabled: false,
                    google_login_enabled: false,
                    microsoft_login_enabled: false,
                    password_login_enabled: true,
                });
            })
            .finally(() => setLoading(false));
    }, [clientId]);

    return { config, loading };
}
